export function parseCurrencyInput(value: string): number | null {
  const trimmed = value.trim();

  if (!trimmed) {
    return null;
  }

  const parsed = Number(trimmed.replace(/\./g, "").replace(",", "."));

  if (!Number.isFinite(parsed)) {
    return null;
  }

  return parsed;
}
